export default __webpack_public_path__ + "static/tabsSectionBg-15148fcad7db7e3202a8dacafc5708a8.png";